import React, { useEffect } from "react";
import { BiChevronsRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { noticeList } from "../../actions/noticeActions";

export const NoticeLister = ({ title, id, dated }) => {
  return (
    <div className="flex items-center cursor-pointer my-8">
      <BiChevronsRight />
      <div className="flex items-center gap-x-3">
        <p>
          <Link to={`/notice/${id}`}>{title}</Link>
        </p>
        <p className="text-gray-400 text-xs">{dated}</p>
      </div>
    </div>
  );
};

const Notice = () => {
  const dispatch = useDispatch();

  const listNotice = useSelector((state) => state.listNotice);
  const { notices } = listNotice;

  useEffect(() => {
    dispatch(noticeList);
  }, [dispatch]);

  return (
    <div className="border bg-gray-50 shadow-lg">
      <div className="bg-white border-b p-2 flex justify-between items-center">
        <h1 className="text-center text-lg font-serif">Notice Board</h1>
        <p className="text-xs font-semibold text-blue-700 cursor-pointer">
          View All
        </p>
      </div>
      <div className="p-2">
        <ul>
          {notices.map((data) => (
            <li className="" key={data.notice_id}>
              <NoticeLister
                title={data.notice_title}
                id={data.notice_id}
                dated={data.date}
              />
            </li>
          ))}
          <li className="">
            <NoticeLister title="Reopining School Date and Importants Notes" />
          </li>
          <li className="">
            <NoticeLister title="Examination Results" />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Notice;
